module.exports = __webpack_public_path__ + "img/WechatCustomerservice.b12b90e4.png";